module.exports = __webpack_public_path__ + "static/media/nav-bar.b493b4ab.png";